import React from 'react';
import PropTypes from 'prop-types';

import { classNames } from '../../utilities';

import styles from './Header.css';

/**
 * **Note**: This component relies on the `--themeHue` and `--themeSaturation` variables for colour
 * styling. See the [Theming section](/#/Components) for instructions on how to pass those
 * variables.
 */
export const Header = ({ navItems, schoolName, title }) => (
  <header className={styles.header}>
    <div className={styles.innerHeader}>
      <span className={styles.headerSchoolName}>{schoolName}</span>
      <h1 className={styles.headerSectionTitle}>{title}</h1>

      {navItems && (
        <nav>
          <ul className={styles.headerNav}>
            {navItems.map(({ active, url, value }) => (
              <li className={styles.headerNavItem} key={url}>
                <a
                  className={classNames(styles.headerNavItemLink, active && styles.isActive)}
                  href={url}>
                  {value}
                </a>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  </header>
);

Header.propTypes = {
  // eslint-disable-next-line react/require-default-props
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      url: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    }).isRequired
  ),
  schoolName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
